export default __webpack_public_path__ + "static/media/white.b5cdcaae.svg";